"use strict";
// Global vars
var scrollAnimate = require("../components/scrollAnimate");
const { lazyLoadVideos } = require("../components/lazyvideo");
const debounce = require("lodash/debounce");
const refinementBar = $(".refinement-bar");
const overlay = $(".selector-overlay");
let prevScrollPos = window.scrollY;
const { pageViewEvent, searchEvent, sortInteractionEvent, featuredTileClick, viewItemListEvent, filterInteractionEvent } = require("../helpers/gtmHelpers");
let savedContentTiles;

const { removeRefinementFromURL } = require("../utils/urlUtils");

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    const $updates = $results.find(selector);
    $(selector).empty();
    if (selector === ".product-grid") {
        $(selector).first().html($updates.html());
    } else {
        $(selector).html($updates.html());
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        $(this).removeClass("active");
        var activeDiv = $results.find("." + $(this)[0].className.replace(/ /g, "."));
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    $(".refinement-card-body:not(.d-none)").each(function () {
        let oldSelectedId = $(this).attr("id");
        $results.find("#" + oldSelectedId).removeClass("d-none");
    });

    updateDom($results, ".refinement-bar");
    updateDom($results, ".refinements");
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".header-bar",
        ".header.page-title",
        ".product-grid",
        ".show-more",
        ".filter-bar",
        ".count-filter .search-result-count",
        ".results-wrapper .search-result-count",
        ".grid-footer",
        ".category-buttons-wrapper"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));
    var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;
    sortOptions.forEach(function (option) {
        $("option." + option.id).val(option.url);
    });
}

function stickyFiltersObserver(element, stickyClass) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                element.classList.remove(stickyClass);
            } else {
                element.classList.add(stickyClass);
            }
        });
    });

    return observer;
}

/**
 * Toggles the visibility of the refinement bar and overlays, and toggles the body scroll
 */
function toggleRefinements() {
    $("body").toggleClass("no-scroll");
    refinementBar.toggleClass("d-none open");
    overlay.toggleClass("active");
}

/**
 * Creating named functions to be able to remove scroll events later
 */
const scrollEventHandlerDesktop = debounce(() => headerAndFiltersPositionOnScroll(document.querySelector(".filter-bar-content")), 50);
const scrollEventHandlerMobile = debounce(() => headerAndFiltersPositionOnScroll(document.querySelector(".count-filter")), 50);

/**
 * Adjusts the position of the header and filters on scroll
 * @param {Element} element - the target element to adjust position
 * @returns {void}
 */
function headerAndFiltersPositionOnScroll(element) {
    const currentScrollPos = window.scrollY;

    if (prevScrollPos > currentScrollPos) {
        element.classList.add("with-header");
    } else {
        element.classList.remove("with-header");
    }

    prevScrollPos = currentScrollPos;
}

/**
 * Initializes the sticky filters for mobile view
 * @returns {void}
 */
function initMobileStickyFilters() {
    const resultsWrapper = document.querySelector(".results-wrapper");
    const filtersBtn = document.querySelector(".count-filter");

    if (!resultsWrapper || !window.matchMedia("(max-width: 991px)").matches) {
        return;
    }

    window.removeEventListener("scroll", scrollEventHandlerDesktop);
    window.removeEventListener("scroll", scrollEventHandlerMobile);

    const observer = stickyFiltersObserver(filtersBtn, "sticky-filters");

    observer.observe(resultsWrapper);
    window.addEventListener("scroll", scrollEventHandlerMobile, {passive: true});
}

/**
 * Initializes the sticky filters for desktop view
 * @returns {void}
 */
function initDesktopStickyFilters() {
    const filterBarWrapper = document.querySelector(".filter-bar-wrapper");
    const filterBarContent = document.querySelector(".filter-bar-content");

    if (!filterBarContent || !window.matchMedia("(min-width: 992px)").matches) {
        return;
    }

    window.removeEventListener("scroll", scrollEventHandlerDesktop);
    window.removeEventListener("scroll", scrollEventHandlerMobile);

    const observer = stickyFiltersObserver(filterBarContent, "sticky-bar");

    observer.observe(filterBarWrapper);
    window.addEventListener("scroll", scrollEventHandlerDesktop, {passive: true});
}

/**
* Updates the count of applied filters and appends it to the filter bar
*/
function updateChipsCount() {
    const filterBar = $(".filter-bar");
    const chipsCount = $(".open-filters .chips-count");
    if (filterBar.first().find("li").length > 0) {
        chipsCount.text(" (" + filterBar.first().find("li").length + ")");
    } else {
        chipsCount.empty();
    }

    if ($(".category-buttons-wrapper").length && $(".desktop-filter-bar li").length) {
        filterBar.addClass("filter-bar-with-category-buttons");
    } else {
        filterBar.removeClass("filter-bar-with-category-buttons");
    }
}

/**
 * Triggers a filter interaction event based on the provided element and filter type.
 *
 * @param {jQuery} element - The jQuery element representing the filter option.
 * @param {boolean} isQuickFilter - Flag indicating if the filter is a quick filter.
 * @returns {void}
 */
function triggerFilterInteractionEvent(element, isQuickFilter) {
    if (!element) {
        return;
    }

    const filterValue = element.data("gtmRefinementValue");
    const filterParent = isQuickFilter ? element.parent() : element.closest(".refinement-card-body");
    const filterName = filterParent.data("gtmRefinementName");

    if (isQuickFilter) {
        if (!element.hasClass("active")) {
            filterInteractionEvent(filterName, filterValue);
        }
        return;
    }

    const isFilterChecked = filterParent.find(".square");
    const isSwatchChecked = filterParent.find(".swatch-mark-wrapper");

    if ((isFilterChecked && !isFilterChecked.hasClass("checked")) && (isSwatchChecked && !isSwatchChecked.hasClass("checked"))) {
        filterInteractionEvent(filterName, filterValue);
    }
}

/**
 * Resets the position of filter arrows for refinement cards
 */
function resetFilterArrowsPosition() {
    const $refinementCardBodys = $(".refinement-card-body");
    $refinementCardBodys.each(function () {
        if ($(this).is(":visible")) {
            let wrapper = $(this).closest(".refinement-card-wrapper");
            wrapper.find(".chevron-down").addClass("d-none");
            wrapper.find(".chevron-up").removeClass("d-none");
        }
    });
}

/**
 * Collects and saves content tiles from the product elements on the page.
 * Iterates through all elements with the class "product-elements" and checks if they have the class "content-element".
 * If they do, it saves the HTML content and its position in an array.
 *
 * @returns {Array<Object>} An array of objects representing the content tiles, each containing:
 *   - {string} html: The HTML content of the tile.
 *   - {number} position: The position index of the tile within the product elements.
 */
function saveContentTiles() {
    const productElements = $(".product-elements");
    const contentTiles = [];

    productElements.each(function (index) {
        const $element = $(this);
        if ($element.hasClass("content-element")) {
            contentTiles.push({
                html: $element.html(),
                position: index,
                isWideClass: $element.hasClass("content-element-wide") ? "content-element-wide" : ""
            });
        }
    });

    return contentTiles;
}

/**
 * Updates the current URL's query parameter for "start" and modifies the browser's history state.
 *
 * @param {number|null} start - The starting point to set in the URL's query parameter. If null, the "start" parameter is removed from the URL.
 */
function updateURL(start) {
    const url = new URL(window.location);
    if (start !== null) {
        url.searchParams.set("start", start);
    } else {
        url.searchParams.delete("start");
    }
    history.pushState(null, "", url.toString());
}

/**
 * Reinserts saved content tiles into the product elements container.
 *
 * @param {Array} savedContentTiles - An array of saved content tiles, where each tile is an object containing:
 * @param {string} tile.html - The HTML content of the tile.
 * @param {number} tile.position - The original position index where the tile should be reinserted.
 */
function reinsertContentTiles(savedContentTiles) {
    savedContentTiles.forEach(tile => {
        const productElements = $(".product-elements");
        const $newElement = $("<div>").addClass(`product-elements content-element ${tile.isWideClass}`).html(tile.html);
        // Insert at the original position
        productElements.eq(tile.position).before($newElement);
    });
}

/**
* Checks if more than one product type filter is selected.
*
* This function determines whether there are any product type filters selected
* in the product listing page (PLP).
*
* @returns {boolean} - Returns true if more than one product type filter is selected, otherwise false.
*/
function hasProductTypeFilterSelected() {
    const productTypeRefinementsContainer = document.getElementById("refinement-product-type");
    const selectedFilters = productTypeRefinementsContainer &&
        productTypeRefinementsContainer.querySelectorAll(":scope .selected");

    if (!selectedFilters || !selectedFilters.length) {
        return false;
    }

    return selectedFilters.length !== 0;
}

/**
* Encodes a URLSearchParams object into a query string.
*
* This function takes a URLSearchParams object, iterates over its entries,
* and encodes each key-value pair into a query string format where both
* keys and values are URL-encoded.
*
* @param {URLSearchParams} searchParams - The URLSearchParams object containing the query parameters.
* @returns {string} A URL-encoded query string.
*/
function encodeQueryParams(searchParams) {
    const params = [];
    for (const [key, value] of searchParams.entries()) {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    return params.join("&");
}

/**
* Generates an updated URL with encoded query parameters for refining search results.
*
* @param {string} url - The URL containing the new query parameters to be added.
* @returns {string} - The updated URL with encoded query parameters.
*/
function getUpdateRefinementUrl(url) {
    const urlObject = new URL(window.location.href);
    const urlParams = new URL(url, urlObject.origin).searchParams;
    const encodedParams = encodeQueryParams(urlParams);
    return urlObject.origin + urlObject.pathname + "?" + encodedParams;
}

/**
* Updates the current browser URL with a refined query string without reloading the page.
* This function modifies the browser's history state to reflect the updated URL query parameters.
*
* @param {string} url - The original URL that needs to be refined and updated in the browser's history.
*/
function updateRefinementUrl(url) {
    const updatedUrl = getUpdateRefinementUrl(url);
    const query = updatedUrl.substring(updatedUrl.indexOf("?") + 1, updatedUrl.length);

    window.history.replaceState(null, "", `?${query}`);
}

module.exports = {
    init: function () {
        updateChipsCount();
    },

    triggerGtmEvents: function () {
        const pageType = $(".found-results-wrapper").length || $(".no-results-wrapper").length ? "Search Results" : "PLP";
        pageViewEvent(pageType);
        if (!$(".no-results-wrapper").length) {
            viewItemListEvent(pageType);
        }
    },

    triggerTileClickEvent: function () {
        $(document).on("click", ".plp-insert", function () {
            featuredTileClick($(this).data("gtm"));
        });
    },

    openRefinements: function () {
        $(document).on("click", ".open-filters", toggleRefinements);
    },

    closeRefinements: function () {
        $(document).on("click", ".product-filter-header-close, .selector-overlay, .apply-filter", function () {
            if (!refinementBar.hasClass("d-none")) {
                toggleRefinements();
            }
            scrollAnimate($(".plp-top"));
        });
    },

    mobileStickyFilters: function () {
        initMobileStickyFilters();
        $(window).on("resize", initMobileStickyFilters);
    },

    desktopStickyFilters: function () {
        initDesktopStickyFilters();
        $(window).on("resize", initDesktopStickyFilters);
    },

    sort: function () {
        // Handle sort order menu selection
        $("body").on("change", "[name=sort-order]", function (e) {
            e.preventDefault();

            $.spinner().start();

            let selectedUrl = this.value;

            $(this).trigger("search:sort", selectedUrl);
            $.ajax({
                url: selectedUrl,
                data: { selectedUrl: selectedUrl },
                method: "GET",
                success: function (response) {
                    updateRefinementUrl(selectedUrl);
                    $(".product-grid-wrapper").empty().html(response);
                    sortInteractionEvent();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {


        // Show more products
        $("body").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data("url");
            e.preventDefault();

            $.spinner().start();
            $(this).trigger("search:showMore", e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: "GET",
                success: function (response) {
                    const results = $(response);
                    if (results.length) {
                        $(".product-grid").append(results.filter(".product-grid")[0].childNodes);
                    }
                    $(".grid-footer").replaceWith(results.filter(".grid-footer")[0]);
                    updateSortOptions(response);
                    viewItemListEvent("PLP");
                    $.spinner().stop();

                    const shownProductsNumber = +$(response).find(".product-start-count").val();
                    updateURL(shownProductsNumber);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $("body").on(
            "click",
            ".refinements li button, button.reset, .filter-value button, .swatch-filter button, .category-buttons-wrapper button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();

                const $element = $(this);
                let refinementUrl = $element.data("href");
                const selectedPillRefinement = document.querySelector(".plp-category-button.active");
                const selectedPillRefinementId = selectedPillRefinement && selectedPillRefinement.getAttribute("data-refinement-id");
                const isCategorySearchAttr = selectedPillRefinement && selectedPillRefinement.getAttribute("data-is-category-search");
                const isCategorySearch = isCategorySearchAttr && isCategorySearchAttr === "true";
                const isRemoveSelectedPillRefinementFromRequest = !$element.hasClass("selected") &&
                    selectedPillRefinement &&
                    !isCategorySearch &&
                    $element.data("refinement-id") !== selectedPillRefinementId &&
                    hasProductTypeFilterSelected();

                // TODO - move the url logic to server side and clear the client side here

                if (isRemoveSelectedPillRefinementFromRequest) {
                    refinementUrl = removeRefinementFromURL(
                        refinementUrl,
                        selectedPillRefinementId
                    );
                }

                $element.trigger("search:filter", e);
                var attributeId = "#" + $element.find("span").last().attr("id");

                // Capture the current sort order value
                const sortRuleMatch = $("[name=sort-order]").val() ? $("[name=sort-order]").val().match(/srule=([^&]*)/) : null;
                const sortRule = sortRuleMatch && sortRuleMatch[1] ? sortRuleMatch[1] : null;

                if (sortRule) {
                    // Remove any existing srule parameter from the URL
                    refinementUrl = refinementUrl.replace(/srule=[^&]*&?/, "");

                    // Append the current sort parameter to the filter URL
                    refinementUrl += (refinementUrl.includes("?") ? "&" : "?") + "srule=" + encodeURIComponent(sortRule);
                }

                $.ajax({
                    url: refinementUrl,
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: refinementUrl
                    },
                    method: "GET",
                    success: function (response) {
                        if ($element.data("gtmRefinementValue") !== undefined) {
                            const isQuickFilter = $element.hasClass("plp-category-button");
                            triggerFilterInteractionEvent($element, isQuickFilter);
                        }

                        updateRefinementUrl(refinementUrl);
                        parseResults(response);
                        reinsertContentTiles(savedContentTiles);
                        lazyLoadVideos();
                        updateChipsCount();
                        initDesktopStickyFilters();
                        initMobileStickyFilters();
                        resetFilterArrowsPosition();
                        $.spinner().stop();
                        scrollAnimate($(".plp-top"));
                        $(attributeId).parent("button").focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $(".container").on("click", ".content-search", function () {
            if ($("#content-search-results").html() === "") {
                getContent($(this), $("#content-search-results"));
            }
        });

        // Display the next page of content results from the search
        $("body").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    toggleAttributes: function () {
        $("body").on("click", ".refinement-card-header,.sort-order-menu-wrapper", function () {
            let $header = $(this);
            $header.closest(".refinement-card-wrapper").find(".refinement-card-body").toggleClass("d-none");
            $header.find(".chevron-up").toggleClass("d-none");
            $header.find(".chevron-down").toggleClass("d-none");
        });
    },
    /**
     * Updates the content tile by adding a CSS class to the parent element
     */
    updateContentTile: function () {
        const productElem = $(".plp-insert.wide");
        if (productElem.length > 0) {
            productElem.each(function () {
                $(this).parents(".content-element").addClass("content-element-wide");
            });
        }

        savedContentTiles = saveContentTiles();
    },

    triggerGTMSearchEvent: function () {
        // Handle search button click and ENTER
        $(".header-search-form").on("submit", searchEvent);
    }
};
